// extracted by mini-css-extract-plugin
export default {"root":"IconJamIconsOutlineLogosTwitte_root__IV2y5","vector":"IconJamIconsOutlineLogosTwitte_vector__0xogl","icon":"IconJamIconsOutlineLogosTwitte_icon__8qDXp"};